import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import api from './api/index'

Vue.prototype.$api = api

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/theme/index.css'

Vue.use(ElementUI);

import 'swiper/css/swiper.min.css'
// import 'swiper/js/swiper.min.js'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

// 公用样式
import "./assets/css/public.scss"

// 公用组件
import combanner from '@/components/combanner/index'

Vue.component("combanner", combanner);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
